import * as React from 'react';
import styled from 'styled-components';
import moment, {Moment} from 'moment';
import {getCurrencyChar} from 'helpers/get-price-label';
import {PriceObject} from 'types';
import {transparentize} from 'polished';
import {DashboardProps} from '../index';
import {DateFormat} from 'components/CoursePromo/types';
import {transition} from "helpers/css";
import {navigateTo} from "helpers/navigate-to";
import {Theme} from '../../../stores/AppStore';

export type LastTransactionsProps = Pick<DashboardProps, 'lastTransactions'>

export interface LastTransactionItem {
  title: string;
  date: Moment;
  userName: string;
  price: PriceObject;
}

export const Container = styled.div`
  box-sizing: border-box;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid ${({theme}) => theme.variables.borderColor};
  background-color: ${({theme}) => theme.variables.accentBackgroundColor};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: ${({theme}) => transparentize(.98, theme.colors.white)};
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
`;

export const ButtonShowAll = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  margin-left: auto;
  color: ${({theme}) => theme.colors.primaryLight};
  cursor: pointer;

  ${transition()}

  &:hover {
    color: ${({theme}) => theme.colors.blueViolet};
  }
`;

export const Content = styled.div`
`;

export const Item = styled.div`
  display: grid;
  gap: 6px;
  padding: 10px 20px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
`;

export const ItemValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
`;

export const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  
  ${ItemValue} {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${({theme}) => `
      ${theme.name === Theme.Dark ? transparentize(.6, theme.colors.white) : transparentize(.6, '#000000')};
    `};
  }
`;

export const ItemBody = styled.div`
  display: flex;
  justify-content: space-between;
`;

/**
 * The function render Category item
 * @param {LastTransactionsProps} props
 * @constructor
 */
export default function LastTransactions({
  lastTransactions,
}: LastTransactionsProps) {
  /**
   * The function render transaction item
   * @param {any} item
   * @constructor
   */
  function renderItem(item: LastTransactionItem) {
    const date = moment(item.date).format(DateFormat.Full);
    const currency = getCurrencyChar(item.price.currency);

    return (
      <Item key={item.userName + moment(item.date).valueOf()}>
        <ItemHeader>
          <ItemValue>{item.title}</ItemValue>
          <ItemValue>{date}</ItemValue>
        </ItemHeader>
        <ItemBody>
          <ItemValue>{item.userName}</ItemValue>
          <ItemValue>{item.price.amount} {currency}</ItemValue>
        </ItemBody>
      </Item>
    );
  }

  /**
   * The navigation handler function
   * @constructor
   */
  function navigateHandler() {
    navigateTo('payments')
  }

  return (
    <Container>
      <Header>
        <Title>Последние транзакции</Title>
        <ButtonShowAll onClick={navigateHandler}>Все</ButtonShowAll>
      </Header>
      <Content>
        {lastTransactions.map(renderItem)}
      </Content>
    </Container>
  );
}
